export default __webpack_public_path__ + "static/media/john.3a810884.jpg";